import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AspGarageSidebarService } from './asp-garage-sidebar.service';
import { ToastrService } from 'ngx-toastr';
import { AspLoadingService } from '../asp-loading/asp-loading.service';

@Component({
  selector: 'app-asp-garage-sidebar',
  templateUrl: './asp-garage-sidebar.component.html',
  styleUrls: ['./asp-garage-sidebar.component.scss']
})
export class AspGarageSidebarComponent implements OnInit {
  garageList:any = [];
  garageKey: any;
  isVisible: boolean;
  searchText:string = '';
  garagename: any;
  filteredGarage: any;
  selectedGarageKey:any=[];
  spareGarageId: string;
  isInputVisible: boolean;
  loading: boolean = true;

  constructor(
    private aspGarageSidebarService:AspGarageSidebarService,
    private toastr: ToastrService, 
    private router: Router,
    private aspLoadingService: AspLoadingService
  ) { }

  ngOnInit(): void {    
    this.garageKey = localStorage.getItem("garageKey");
    this.getGaragesList();
  }

  closeSidebar(ishide: boolean) {
    this.isVisible = ishide;
     this.searchText = ''; 
  }
 
  getGaragesList(){
    let spareUserKey = localStorage.getItem('spareUserKey');
    this.aspLoadingService.show();
    this.aspGarageSidebarService.getUserDetails(spareUserKey).subscribe(
      result => {
        this.aspLoadingService.hide();
        // console.log("gragedata",result);
        let res = JSON.parse(JSON.stringify(result)); 
        if(res.code && res.code==200){
          this.garageList = res.data.garage;
          const selectedGarage = this.garageList.find(g => g.garageKey === this.garageKey);
          const others = this.garageList.filter(g => g.garageKey !== this.garageKey);
          const sortedOthers = others.sort((a, b) => a.name.localeCompare(b.name));
          localStorage.setItem("agentKey", res.data.agentKey);
          const permission = res.data.rolePermissionResponses?.find(
            (p: any) => p.permissionCode === 'create_so'
          );

          localStorage.setItem(
            'createorderpermission',
            permission?.permission ? 'true' : 'false'
          );
        //  console.log(
        //     "permission from api",
        //     permission?.permission
        //   );

        //   console.log(
        //     "permission in localstorage",
        //     localStorage.getItem('createorderpermission')
        //   );
          if (selectedGarage) {
            this.filteredGarage = [selectedGarage, ...sortedOthers];
          } else {
            // fallback in case no selection found
            this.filteredGarage = [...sortedOthers];
          }

          
          // localStorage.setItem('merchantid', res.data.garage.spareGarageId[0]);

        }
        

        else{
          this.toastr.error(res.message, 'Error');
        }
        // localStorage.setItem('merchantId', this.spareGarageId);
      }
    );
  }
  selectGarage(garageKey, garageName,contactName,contactEmail,contactPhone,spareGarageId,garageType, zone){
    localStorage.removeItem('addedCart');
    localStorage.removeItem('requestCartInfo');
    localStorage.removeItem('requestSummary');
    localStorage.removeItem('fromRequestPage');
    localStorage.removeItem('requestId');
    localStorage.removeItem('addedRedeem');
    localStorage.removeItem('redeemCart');
    localStorage.setItem("garageKey", garageKey);
    localStorage.setItem("spareSelectedGarageName", garageName);
    localStorage.setItem("contactName", contactName);
    localStorage.setItem("contactEmail", contactEmail);
    localStorage.setItem("contactPhone", contactPhone);
    localStorage.setItem("merchantId",spareGarageId);
    localStorage.setItem("type",garageType);
    localStorage.setItem("zone", zone);
    this.router.navigate(['/home']).then(() => {
      window.location.reload();
     });
    this.toastr.success(garageName+' selected successfully', 'Garage selected');
    this.closeSidebar(false);
  }

  clearSearch() {
     this.searchText = ''; 
     this.searchFilterType();
   }
searchFilterType = () => {
  const search = this.searchText?.trim().toLowerCase() || '';

  const filtered = this.garageList.filter(garage => {
    const nameMatch = search
      ? garage.name?.toLowerCase().includes(search)
      : true;

    const zohoIdMatch = search
      ? garage.zohoCustomerId?.includes(search)
      : true;

    const statusMatch = search
  ? (
      (garage.status === 1 ? 'active' : 'inactive')
        .toLowerCase()
        .includes(search)
    )
  : true;


    const zoneMatch = search
      ? garage.zone?.replace("Autoverse Commerce - ", "")
          .toLowerCase()
          .includes(search)
      : true;

    return nameMatch || zohoIdMatch ||statusMatch  || zoneMatch;
  });

  // put selected garage on top + sort others
  const selectedGarage = filtered.find(g => g.garageKey === this.garageKey);
  const others = filtered.filter(g => g.garageKey !== this.garageKey);

  const sortedOthers = others.sort((a, b) =>
    (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
  );

  this.filteredGarage = selectedGarage
    ? [selectedGarage, ...sortedOthers]
    : [...sortedOthers];
};

 @ViewChild('garageSearchInput') garageSearchInput!: ElementRef<HTMLInputElement>;

garageSearch() {
    this.isInputVisible = !this.isInputVisible;
    // console.log("isInputVisible", this.isInputVisible)
    if (this.isInputVisible) {
      setTimeout(() => {
       
       if (this.isInputVisible) {
      // Wait for DOM update
      setTimeout(() => {
        if (this.garageSearchInput) {
          this.garageSearchInput.nativeElement.focus();
        }
      });
    } else {
          console.error('SearchInput not found');
        }
      }, 0);
    }
}

highlightMatch(name: string, type?: string): string {
  if (!this.searchText) return name || '';

  const escaped = this.searchText.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
  const regex = new RegExp(`(${escaped})`, 'gi');

  const highlightClass = type === 'zone' ? 'highlight-zone-text' : 'highlight-text';

  return (name || '').replace(regex, `<span class="${highlightClass}">$1</span>`);
}




}
